import type { VideoVersion } from '../lib/types'
import { Check, Loader2, AlertTriangle } from 'lucide-react'

interface Props {
  versions: VideoVersion[]
  selectedVersion: number | null
  onSelect: (version: number) => void
}

export default function VersionDropdown({ versions, selectedVersion, onSelect }: Props) {
  return (
    <div>
      <div className="text-xs font-semibold uppercase tracking-wide text-slate-500 mb-2">
        Versions (newest first)
      </div>
      <div className="flex flex-wrap gap-2">
        {[...versions].reverse().map((v) => {
          const isSelected = v.version === selectedVersion
          const isReady = v.status === 'ready'
          const isProcessing = v.status === 'processing'
          const isFailed = v.status === 'failed'
          return (
            <button
              key={v.version}
              onClick={() => isReady && onSelect(v.version)}
              disabled={!isReady}
              className={[
                'inline-flex items-center gap-2 rounded-lg border px-3 py-2 text-sm font-medium transition',
                isSelected
                  ? 'border-ub-blue-500 bg-ub-blue-50 text-ub-blue-800'
                  : isReady
                  ? 'border-slate-200 bg-white text-slate-700 hover:border-slate-300 hover:bg-slate-50'
                  : 'border-slate-200 bg-slate-50 text-slate-400 cursor-not-allowed',
              ].join(' ')}
            >
              {isSelected && <Check className="h-3.5 w-3.5" />}
              {isProcessing && <Loader2 className="h-3.5 w-3.5 animate-spin" />}
              {isFailed && <AlertTriangle className="h-3.5 w-3.5 text-red-500" />}
              <span>v{v.version}</span>
              {isProcessing && <span className="text-xs text-slate-500">rendering</span>}
              {isFailed && <span className="text-xs text-red-500">failed</span>}
            </button>
          )
        })}
      </div>
    </div>
  )
}
